"use client";

import { Button, Toast } from "@heroui/react";
import { useState } from "react";

import { signIn } from "@/lib/auth-client";

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" className="size-4" aria-hidden>
    <path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.5a5.6 5.6 0 0 1-2.4 3.7v3h3.9c2.3-2.1 3.5-5.2 3.5-8.9Z" />
    <path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.9-3c-1.1.7-2.4 1.2-4 1.2-3.1 0-5.7-2.1-6.6-4.9H1.4v3.1A12 12 0 0 0 12 24Z" />
    <path fill="#FBBC05" d="M5.4 14.4a7.2 7.2 0 0 1 0-4.6V6.7H1.4a12 12 0 0 0 0 10.8l4-3.1Z" />
    <path fill="#EA4335" d="M12 4.8c1.8 0 3.4.6 4.6 1.8l3.4-3.4A12 12 0 0 0 1.4 6.7l4 3.1C6.3 6.9 8.9 4.8 12 4.8Z" />
  </svg>
);

/**
 * Google is the only social provider, and it is trusted for account linking —
 * it verifies addresses itself, so a Google sign-in can safely attach to an
 * existing email/password account.
 */
export function GoogleButton({ next }: { next?: string }) {
  const [isPending, setIsPending] = useState(false);

  async function handlePress() {
    setIsPending(true);

    const { error } = await signIn.social({
      provider: "google",
      callbackURL: next || "/dashboard",
    });

    if (error) {
      Toast.toast.danger(error.message ?? "Google sign-in failed");
      setIsPending(false);
    }
    // On success the browser navigates away, so the pending state is never
    // cleared — deliberately, since clearing it would flash the button back to
    // idle mid-redirect.
  }

  return (
    <Button
      variant="secondary"
      fullWidth
      onPress={handlePress}
      isPending={isPending}
      className="gap-2.5"
    >
      <GoogleIcon />
      Continue with Google
    </Button>
  );
}
